'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const BulletList = renderWithRef('BulletList', null, (e, l)=>jsx(RenderComp, {
        root: "ul",
        forwardedRef: l,
        classNames: [
            'swan-bullet-list'
        ],
        props: e,
        children: e.children
    }));

export { BulletList };
